export default "__VITE_ASSET__8rZ76GA7__"